import { merge } from 'lodash';

const initialState = {
  /* Campos etapa 1 */
  titulo: '',
  obras: '',
  centrosCusto: '',
  tipos: '',
  dataLancamentoInicio: null,
  dataLancamentoFim: null,

  /* Campos etapa 2 */
  percentuais: {
    DepAtivosEletricos: { label: 'Depreciação dos Ativos Elétricos', perc: '100' },
    DepAne: { label: 'Depreciação ANE', perc: '100' },
    IrContSocial: { label: 'IR + Cont Social', perc: '100' }
  }
};

const state = initialState;

const getters = {};

const actions = {
  setPerdasAic({ commit }, value) {
    commit('SET_PERDAS_AIC', value);
  },
  clearPerdasAic({ commit }) {
    commit('CLEAR_PERDAS_AIC', initialState);
  }
};

const mutations = {
  SET_PERDAS_AIC: (state, value) => (state = merge(state, value)),
  CLEAR_PERDAS_AIC: (state, value) => {
    state = merge(state, value);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
